import { hfbXxxStringTranslator } from "@coworker/locales";

export function formatLocationName(
  location: string,
  t: (key: string, options?: any) => string
): string {
  if (!location) return "";

  if (location.match(/^[0-9][0-9]$/)) {
    return `HFB ${location} - ${hfbXxxStringTranslator(location, t)}`;
  }

  if (location === "SFM") {
    return t("otherAreaSwedishFoodMarketString");
  }

  if (location === "MOW") {
    return t("markethallOpenTheWalletString");
  }

  if (location === "SOW") {
    return t("showroomOpenTheWalletString");
  }

  let translationString = "";
  switch (location) {
    case "AsIs":
    case "ClickAndCollect":
    case "Bistro":
    case "Checkout":
    case "CustomerServiceArea":
    case "EntranceInclGreeter":
    case "FinancingArea":
    case "FirstRoom":
    case "FullServeHandouts":
    case "HomeServicePointPlanningStudio":
    case "IKEAForBusiness":
    case "IKEARestaurant":
    case "IngkaCenters":
    case "OpenTheWalletMarkethall":
    case "OpenTheWalletShowroom":
    case "ParkingZone":
    case "PickUpPointHub":
    case "QuestionsFromCoWorkers":
    case "Restaurant":
    case "SelfServe":
    case "Smaland":
    case "SwedishFoodMarket":
      translationString = `otherArea${location}String`;
      break;
    case "whole":
      translationString = "wholeStoreString";
      break;
  }
  if (translationString) {
    return t(translationString);
  }

  const translated = hfbXxxStringTranslator(location, t);
  if (translated && translated !== location) {
    return translated;
  }

  return location;
}
